{
  "add_company": "Add a Company",
  "alert_sensitivity_level": {
    "option": {
      "normal": "Normal",
      "sensitive": "Sensitive",
      "tolerant": "Tolerant"
    }
  },
  "alert_settings": {
    "alert_settings": {
      "all_alerts": {
        "alert": {
          "customized": "Customized",
          "description_prefix": "Alert Content: ",
          "new_custom_rule": "New Custom Rule"
        },
        "error": "There was an error loading all alerts",
        "title": "All Alerts"
      },
      "custom_rules": {
        "confirm_delete": {
          "button": "Delete custom rule",
          "text": "Are you sure you want to delete this custom rule?"
        },
        "delete": {
          "api_error": "There was an error deleting an alert settings override"
        },
        "table": {
          "cell": {
            "action": {
              "delete": "Delete custom rule",
              "edit": "Edit custom rule"
            },
            "circuit": {
              "more": "{{count}} more"
            },
            "sites": {
              "all": "ALL ({{sitesCount}})",
              "tooltip": {
                "all_sites_title": "This rule applies to all sites.",
                "sites_title": "Sites affected"
              }
            }
          },
          "column": {
            "default_severity": "Default Severity",
            "name": "Name",
            "severity": "Current Severity",
            "sites": "Sites Affected",
            "type_ids": "Circuit Types",
            "usage_ids": "Circuit Usages"
          },
          "no_data": "No custom rules set"
        },
        "title": "Custom Rules"
      },
      "info": "You can only set custom rules for the company you are currently viewing. To create custom rules for a child company, you need to access its details.",
      "title": "Alert Settings",
      "wizard": {
        "button": {
          "back": "Back",
          "submit": "Save and Close"
        },
        "error": {
          "conflict": "One or more selected sites already have a custom rule configured for this alert. Please review selected sites and try again.",
          "invalid": "There was an issue with validating the custom rule. Please try again."
        },
        "info": {
          "all_sites_already_overridden": "All sites are currently part of a Custom Rule and can't be selected for a new rule."
        },
        "step": {
          "circuits": {
            "control": {
              "common": {
                "description": "This alert will be disabled for selected circuit options for selected sites",
                "label": "Choose circuit options that will not activate the alert"
              },
              "type_ids": {
                "label": "Circuit type"
              },
              "usage_ids": {
                "label": "Circuit usage"
              }
            },
            "label": "Circuits",
            "types": {
              "cellular": "Cellular / Bigleaf Wireless Connect"
            }
          },
          "severity": {
            "control": {
              "severity": {
                "description": "The severity setting you choose for this alert will override the default severity setting for all selected sites",
                "label": "Adjust alert severity",
                "value": {
                  "default": "{{label}} (Default)",
                  "disabled": "Disabled",
                  "high": "High",
                  "low": "Low",
                  "medium": "Medium"
                }
              }
            },
            "label": "Severity"
          },
          "sites": {
            "control": {
              "all_sites": {
                "info": {
                  "all_sites_unavailable": "Sites that are currently part of a Custom Rule can't be selected for a new rule."
                },
                "label": "Select Sites",
                "reset": "Clear All",
                "value": {
                  "false": "Select Sites",
                  "true": "All Sites"
                }
              },
              "sites": {
                "label": "Select Sites",
                "remove": "Remove"
              }
            },
            "info": "Changing these settings affects the risk calculation algorithm for the selected site(s), which determines when Alerts are triggered. Use caution when changing these settings.",
            "label": "Sites"
          },
          "summary": {
            "label": "Summary",
            "section": {
              "circuits": {
                "exclude": "Circuit options <span>excluded from triggering the alert</span>",
                "include": "Circuit options that activate the alert",
                "label": "Circuits",
                "type_ids": "Circuit type:",
                "usage_ids": "Circuit usage:"
              },
              "overview": {
                "description": "Alert content: {{description}}"
              },
              "severity": {
                "default": "Default: {{severity}}",
                "label": "Severity"
              },
              "sites": {
                "all_sites": "ALL SITES",
                "label": "Sites"
              }
            }
          }
        },
        "title": {
          "create": "New Custom Rule for {{name}}",
          "edit": "Edit Custom Rule for {{name}}"
        }
      }
    },
    "alert_tolerance": {
      "sensitivity_level": {
        "description": "This setting adjusts how our engine calculates alerts. For example, choosing 'sensitive' may result in a higher volume of events triggering alerts.",
        "name": "Sensitivity Level"
      },
      "title": "Alert Tolerance"
    },
    "circuit_types": {
      "api_error": "There was an error loading circuit types"
    },
    "circuit_usages": {
      "api_error": "There was an error loading circuit usages"
    }
  },
  "api_error": "There was an error loading child companies",
  "child": {
    "add_company": "Add company",
    "child_count": "<b>{{count}}</b> Managed companies",
    "columns": {
      "company_type": "Company Type",
      "created_at": "Created",
      "name": "Company Name",
      "own_devices": "Devices",
      "own_sites": "Sites",
      "own_users": "Users",
      "user_role": "Role in Company"
    },
    "no_data": "No child companies available.",
    "title": "Managed companies"
  },
  "companies": "Companies",
  "company_created": "Company {{name}} has been created",
  "company_updated": "Company {{name}} has been updated",
  "create_company": "Create Company",
  "delete_company": {
    "confirm_delete": "Are you sure you want to delete this company?",
    "description": "Deleting a company is a permanent action that cannot be undone. This will erase all associated data and permanently remove all user accounts.",
    "errors": {
      "sites": {
        "close": "Close",
        "company_name": "You’re trying to delete <strong>{{name}}</strong>, but it still has sites linked to it. \nTo delete this company, you must first delete these sites:",
        "delete_sites": "Until these sites are removed, the company cannot be deleted.",
        "title": "You cannot delete a company with sites."
      }
    },
    "reseller_warning": "This company manages other child companies that it created. Deleting this company will also remove all associated child companies and all users associated with these child companies. Click on \"Managed Companies\" to see list of companies",
    "success": "Company deleted",
    "title": "Delete Company"
  },
  "devices": {
    "add": {
      "bulk_load": "Bulk Load CPE",
      "button": "Add a device",
      "modal": {
        "cancel": "Cancel",
        "fields": {
          "company_id": {
            "description": "If no company is selected, the device will be added to the default parent company",
            "label": "Add device to specific company",
            "no_companies": "No Companies found"
          },
          "mac_address": {
            "invalid": "Invalid MAC address",
            "label": "MAC Address",
            "required": "MAC address is required"
          },
          "serial_number": {
            "exists": "The device already exists",
            "invalid": "Invalid serial number",
            "label": "Serial No.",
            "required": "Serial number is required"
          }
        },
        "header": "Add CPE device",
        "submit": "Add device",
        "success": "You've successfully added a new device."
      },
      "single_device": "Add a single device"
    },
    "api_error": "There was an error loading devices.",
    "bulk_load": {
      "modal": {
        "cancel": "Cancel",
        "failure": "Failed to upload all devices. They might already be added.",
        "fields": {
          "company_id": {
            "description": "If no company is selected, the devices will be loaded to the default parent company",
            "label": "Load devices to specific company",
            "no_companies": "No Companies found"
          },
          "device_type": {
            "label": "Device type",
            "required": "Device type is required"
          },
          "file": {
            "description": "Processes a CSV file with a single column of CPE serial and no header.",
            "label": "Upload CSV file",
            "required": "File is required"
          }
        },
        "header": "Bulk Load CPE devices",
        "partial_success": "You've successfully uploaded {{success}} devices. {{failed}} devices failed to upload. They might already be added.",
        "submit": "Bulk Load",
        "success": "You've successfully uploaded all devices."
      }
    },
    "columns": {
      "company_name": "Company",
      "config_ip": "Config ip",
      "device_type": "Device type",
      "firmware_version": "Firmware version",
      "phloem_status": "Server",
      "serial_number": "Serial number",
      "site_name": "Site",
      "state": "State"
    },
    "device_count": "<b>{{count}}</b> Devices",
    "filters": {
      "allocation": "Allocation",
      "device_type": "Device type",
      "firmware_version": "Firmware version",
      "path": "Company > Devices > Devices table",
      "phloem_status": "Server status",
      "site_id": "Site",
      "state": "State"
    },
    "filters_options": {
      "allocation": {
        "allocated": "Allocated",
        "unallocated": "Unallocated"
      },
      "phloem_status": {
        "offline": "Offline",
        "online": "Online"
      }
    },
    "include_managed_companies": "Include devices from managed companies",
    "menu": {
      "button_aria_label": "Open device menu",
      "delete": {
        "cancel": "Cancel",
        "confirm": "Delete Device",
        "confirm_text": "Are you sure you want to delete this Device?",
        "success": "Device has been successfully deleted."
      },
      "edit": {
        "modal": {
          "cancel": "Cancel",
          "fields": {
            "company_id": {
              "helper_text": "The company the site belongs to",
              "label": "Company",
              "not_found": "No companies found",
              "remove": "Remove Company",
              "required": "Company is required"
            },
            "config_ip": {
              "exists": "The IP Address already exists",
              "invalid": "Invalid IP Address",
              "label": "IP Address",
              "required": "IP Address is required"
            },
            "serial_number": {
              "exists": "The device already exists",
              "invalid": "Invalid serial number",
              "label": "Serial No.",
              "required": "Serial number is required"
            }
          },
          "header": "Edit CPE",
          "submit": "Update device config",
          "success": "You've successfully updated device config."
        }
      },
      "options": {
        "delete": "Delete Device",
        "edit": "Edit Configuration",
        "move_device": "Move device",
        "reset": "Reset Encryption Keys"
      },
      "reset": {
        "cancel": "Cancel",
        "confirm": "Reset Encryption Keys",
        "confirm_text": "Are you sure you want to reset the encryption keys?",
        "success": "Encryption keys has been successfully reset."
      }
    },
    "move": {
      "modal": {
        "cancel": "Cancel",
        "fields": {
          "company_id": {
            "helper_text": "Move the device to this company",
            "label": "Company",
            "required": "Company is required"
          },
          "serial_number": {
            "exists": "The device already exists",
            "label": "Serial No."
          }
        },
        "header": "Move CPE device",
        "submit": "Move device",
        "success": "You've successfully moved a new device."
      }
    },
    "no_data": "No devices available.",
    "title": "Devices"
  },
  "export": "Export as CSV",
  "go_to_companies": "Go to Companies",
  "navigation": {
    "alert_settings": "Alert Settings",
    "children": "Managed Companies",
    "devices": "Devices",
    "logs": "Logs",
    "options": "Company Options",
    "sites": "Sites",
    "users": "Users"
  },
  "options": {
    "errors": {
      "api": "The following error occurred saving company options: {{detail}}",
      "error": "There was an issue with saving the company options. Please try again.",
      "invalid": "There was an issue with validating the company options. Please try again.",
      "missing-provider-required": "No parent companies available. This will prevent you from saving."
    },
    "fields": {
      "address": {
        "city": {
          "label": "City"
        },
        "country": {
          "label": "Country"
        },
        "line1": {
          "label": "Company Address Line 1",
          "placeholder": "Search address"
        },
        "line2": {
          "label": "Company Address Line 2",
          "placeholder": "Apartment, landmark, etc."
        },
        "line3": {
          "label": "Company Address Line 3"
        },
        "name": {
          "label": "Company full name"
        },
        "state": {
          "label": "State"
        },
        "zip": {
          "label": "Zip"
        }
      },
      "company_type": {
        "label": "Company Role",
        "options": {
          "Customer": "Customer",
          "Environment Operator": "Environment Operator",
          "Provider": "Provider",
          "Reseller": "Reseller"
        }
      },
      "disable_cpe_upgrades": {
        "description": "Disables all CPE upgrades for all sites associated with this company",
        "label": "Disable CPE Upgrades"
      },
      "hardware_sale_model": {
        "label": "Hardware Sales Model",
        "options": {
          "rental": "Rental",
          "sale": "Sale"
        }
      },
      "in_app_ordering": {
        "label": "In-App Ordering"
      },
      "is_vip": {
        "label": "Enhanced Support"
      },
      "name": {
        "label": "Company Name"
      },
      "provider_id": {
        "label": "Parent Company"
      },
      "sensitivity": {
        "description": "This setting adjusts how our engine calculates alerts. For example, choosing 'sensitive' may result in a higher volume of events triggering alerts.",
        "label": "Alert Tolerance"
      }
    },
    "no_companies_found": "No Companies found",
    "remove_parent_company": "Remove Parent Company",
    "save": "Save settings",
    "title": {
      "company_address": "Company Address",
      "company_options": "Company Options"
    }
  },
  "sites": {
    "api_error": "There was an error loading sites",
    "export_data": "Export as CSV",
    "table": {
      "no_data": "No Sites available"
    },
    "title": "Sites",
    "toggle": "Include sites from managed companies"
  },
  "users": {
    "add": {
      "button": "Add user",
      "existing": {
        "cancel": "Cancel",
        "fields": {
          "company_id": {
            "description": "If no company is selected, the user will be added to the default parent company",
            "label": "Add user to specific company",
            "no_companies": "No Companies found"
          },
          "role_id": {
            "label": "Choose user role"
          },
          "user_id": {
            "exists": "The user already exists",
            "helper_text": "Add user that already has an existing account",
            "label": "Add existing user",
            "not_found": "No users found",
            "remove": "Remove User",
            "required": "User is required"
          },
          "welcome_email": {
            "helper_text": "Welcome email will contain a link with password reset link",
            "label": "Send welcome email to new user"
          }
        },
        "header": "Add existing user",
        "option": "Add existing user",
        "submit": "Add user",
        "success": "User has been successfully added."
      },
      "new": {
        "cancel": "Cancel",
        "fields": {
          "company_id": {
            "description": "If no company is selected, the user will be added to the default parent company",
            "label": "Add user to specific company",
            "no_companies": "No Companies found"
          },
          "email": {
            "exists": "User with this email address already exists",
            "invalid": "Invalid email address",
            "label": "Email",
            "max_length": "Email must be at most 254 characters",
            "placeholder": "User@example.com",
            "required": "Email is required"
          },
          "full_name": {
            "label": "Full name",
            "placeholder": "Enter the Full name",
            "required": "Full name is required"
          },
          "role_id": {
            "label": "Choose user role"
          },
          "timezone": {
            "label": "Timezone",
            "no_results": "No timezones found"
          },
          "username": {
            "exists": "User with this username already exists",
            "label": "Username",
            "max_length": "Username must be at most 32 characters",
            "placeholder": "E.g., jdoe123",
            "required": "Username is required"
          },
          "welcome_email": {
            "helper_text": "Welcome email will contain a link with password reset link",
            "label": "Send welcome email"
          }
        },
        "header": "Invite new user",
        "option": "Invite a new user",
        "submit": "Invite user",
        "success": "User has been successfully invited."
      }
    },
    "api_error": "There was an error loading users.",
    "columns": {
      "companies": "Company",
      "email": "Email",
      "full_name": "User",
      "role": "Role",
      "timezone": "Timezone",
      "username": "Username"
    },
    "companies": {
      "multiple_label": "Multiple companies ({{number}})",
      "tooltip": {
        "title": "Assigned companies and roles"
      }
    },
    "filters": {
      "path": "Company > Users > Users table",
      "timezone": "Timezone",
      "user_role": "User role"
    },
    "manage_roles_drawer": {
      "add_to_company": {
        "button": "Add to another company"
      },
      "description": "You can update this user's role and manage their assignments by adding or removing them from companies.",
      "success": "You’ve successfully updated the user’s role and company assignments.",
      "table": {
        "columns": {
          "name": "Company",
          "role_name": "Role"
        },
        "no_data": "No companies available.",
        "remove": {
          "button": "Remove from company",
          "new_user_button": "Remove"
        }
      },
      "title": "Users",
      "toggle_welcome_email": "Notify user about new assignment(s)",
      "user_exists": "The user already exists in this company."
    },
    "menu": {
      "button_aria-label": "Open user menu.",
      "edit": {
        "option_name": "Edit roles and companies"
      },
      "login": {
        "option_name": "Log in as this user"
      },
      "manage_settings": {
        "option_name": "Manage user’s settings",
        "tooltip": "You don’t have permission to edit this user’s settings."
      },
      "remove": {
        "cancel": "Cancel",
        "confirm": "Remove User",
        "confirm_remove": "Are you sure you want to remove this user?",
        "option_name": "Remove user",
        "success": "User has been successfully removed."
      },
      "reset": {
        "option_name": "Reset password",
        "success": "We've just sent you an email to reset your password."
      }
    },
    "multiple_roles": {
      "label": "Multiple roles"
    },
    "no_data": "No users available.",
    "role_modal": {
      "body_bold_text": "Users with specific permissions based on their role can modify, upgrade, or disable services, including circuit configuration. ",
      "body_text": "By proceeding, you confirm you have the authority to make this change on behalf of your company and that your company accepts responsibility for any changes this user makes.",
      "cancel": "Cancel",
      "confirm": "Change account role",
      "header": "Warning: Changing a user's role in a company",
      "warn_text": "You are about to change a user's role in the company."
    },
    "title": "Users",
    "toggle_managed_users": "Include users from managed companies",
    "update": {
      "success": "The role has been successfully changed."
    },
    "user_count": "<b>{{count}}</b> Users",
    "user_role": {
      "Company Admin": "Company Admin",
      "Disabled": "Disabled",
      "Super Admin": "Super Admin",
      "Unknown": "Unknown",
      "User": "User"
    }
  }
}
